import styled from 'styled-components';
import {RowStyles, ColumnStyles} from './../../../../../../stories/core-components/Layouts/Layouts';

export const AmenitiesPhotosWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 3rem;
`;
export const Header = styled.h3`
  font-size: 1.4rem;
  color: black;
  padding-bottom: 2rem;
`;
export const AmenitiesWrap = styled.section(
  props => `
       ${RowStyles};
       flex-wrap: wrap;
    `,
);

export const Amenities = styled.p`
  ${RowStyles};
  align-items: center;
  padding: 1rem 2rem 1rem 0;
`;
export const AmenitiesTxt = styled.span`
  color: #777777;
  font-size: 1.2rem;
  padding-left: 1rem;
`;
export const PhotosWrap = styled.section`
  padding-top: 3rem;
`;
export const Arrows = styled.span`
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2276e3;
  border-radius: 50%;
  box-shadow: 0 0 4px 0 rgba(95, 95, 95, 0.5);
  position: absolute;
  top: 40%;
  cursor: pointer;
  &.left {
    left: -1.5rem;
  }
  &.right {
    right: -1.5rem;
  }
`;
export const ScrollerWrap = styled.div`
  position: relative;
  padding-top: 1rem;
`;
export const Scroller = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  height: 189px;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ImgBox = styled.div`
  width: 244px;
  height: 189px;
  border-radius: 4px;
  background-color: #dfdfdf;
  margin-right: 2rem;
  display: inline-block;
  overflow: hidden;
  &:last-child {
    margin-right: 0;
  }
`;
